module.exports = __webpack_public_path__ + "img/dne-exchange.af81fbb2.jpg";